/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tagFilled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="m19.707 11.293-11-11A.997.997 0 0 0 8 0H1a1 1 0 0 0-1 1v7c0 .266.105.519.293.707l11 11a.997.997 0 0 0 1.414 0l7-7a.999.999 0 0 0 0-1.414ZM5 7a2 2 0 1 1-.001-3.999A2 2 0 0 1 5 7Z" _fill="#4990E2"/>'
  }
})
